import { render, staticRenderFns } from "./TableAdmin.vue?vue&type=template&id=3aa027da&scoped=true&"
import script from "./TableAdmin.vue?vue&type=script&lang=js&"
export * from "./TableAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TableAdmin.vue?vue&type=style&index=0&id=3aa027da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa027da",
  null
  
)

export default component.exports